function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { DocumentElements } from "./DocumentAssets";
export var Setup;
(function (_Setup) {
  function setupResourceAssets(resources, source) {
    var images = DocumentElements.resolveImage(source);
    var graphicElements = DocumentElements.resolveGraphicElements(source);
    var _iterator = _createForOfIteratorHelper(images),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var image = _step.value;
        resources.loadResource("asset:".concat(encodeURIComponent(image)));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var _iterator2 = _createForOfIteratorHelper(graphicElements),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var graphicElement = _step2.value;
        var properties = graphicElement.properties;
        var url = properties.url,
          palette = properties.palette;
        var search = new URLSearchParams(palette).toString();
        resources.loadResource("asset:".concat(encodeURIComponent(url), "?").concat(search));
      }
      // const mapElements = DocumentElements.resolveMapElements(source);
      // for (let mapElement of mapElements) {
      //     const {
      //         location,
      //         width,
      //         height,
      //         zoom,
      //     } = mapElement.properties;
      //     const target = {
      //         location: location,
      //         size: {
      //             width: width,
      //             height: height,
      //         },
      //         zoom: zoom,
      //     };
      //     const uri = MapResourceLoader.uri(target);
      //     resources.loadResource(uri);
      // }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  _Setup.setupResourceAssets = setupResourceAssets;
})(Setup || (Setup = {}));